import http from '@/api/base'

// 查询字典列表
const selectConfigDictList = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return http.post('/configDict/selectConfigDictList', params)
  } else {
    return http.post('/dcits-consumption/configDict/selectConfigDictList', params)
  }
}

// 查询字典分页列表
const selectConfigDictPage = (params, current, size) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return http.post('/configDict/selectConfigDictPage?current=' + current + '&size=' + size, params)
  } else {
    return http.post('/dcits-consumption/configDict/selectConfigDictPage?current=' + current + '&size=' + size, params)
  }
}

// 添加字典
const addConfigDict = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return http.post('/configDict/addConfigDict', params)
  } else {
    return http.post('/dcits-consumption/configDict/addConfigDict', params)
  }
}

// 删除字典
const delConfigDict = (id) => {
  if (process.env.NODE_ENV === 'development') {
    return http.post(`/configDict/delConfigDict?id=${id}`)
  } else {
    return http.post(`/dcits-consumption/configDict/delConfigDict?id=${id}`)
  }
}

// 修改字典
const modifyConfigDict = (params) => {
  if (process.env.NODE_ENV === 'development') {
    params.consumption = true
    return http.post('/configDict/modifyConfigDict', params)
  } else {
    return http.post('/dcits-consumption/configDict/modifyConfigDict', params)
  }
}

export default {
  selectConfigDictList,
  selectConfigDictPage,
  addConfigDict,
  delConfigDict,
  modifyConfigDict
}



// WEBPACK FOOTER //
// ./src/area-dcits/api/configdict.js